module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image23.72064850.webp";